import { render, staticRenderFns } from "./show.chat-messages.page.vue?vue&type=template&id=2e0a8ccb&"
import script from "./show.chat-messages.page.vue?vue&type=script&lang=js&"
export * from "./show.chat-messages.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports